import { useParams } from "react-router-dom";
import ContentHeader from "../../widgets/contentHeader/ContentHeader";
import { DateFilter } from "../../widgets/weatherStationReview/DateFilter";
import { DetailedHourInfoSection } from "../../widgets/weatherStationReview/detailedHourInfoSection/DetailedHourInfoSection";
import { HourMeasurementList } from "../../widgets/weatherStationReview/hourMeasurementList/HourMeasurementList";

export function WeatherStationReviewPage() {
    const { stationId } = useParams();

    return (
        <>
            <ContentHeader title="Метеостанция" />
            <div className="weather-station-review-page-div">
                <DateFilter />
                <HourMeasurementList/>
                <DetailedHourInfoSection />
            </div>
        </>
    )
}
